<template>
    <div class="role_setting_section">
        <div class="sea_bar cl">
            <div class="l">
                <div class="l filter_item inpt">
                    <el-input placeholder="帐号" icon="search" :on-icon-click="loadListData" v-model="filter.username" @blur="loadListData"></el-input>
                </div>
            </div>
            <div class="l">
                <div class="l filter_item inpt">
                    <el-input placeholder="姓名" icon="search" :on-icon-click="loadListData" v-model="filter.contact" @blur="loadListData"></el-input>
                </div>
            </div>
            <div class="l filter_item form_line sel">
                <div class="l inpt org_select">
                    <el-input placeholder="所属部门" v-model="filter.curOrgNode.organizationname" @focus="showOrgTree" @change="handleFilterOrg"></el-input>
                    <i class="el-icon-caret-bottom spe-parentOrg-down-btn placeholderColor" @click="showOrgTree"></i>
                    <el-tree class="org_tree" 
                        v-show="filter.orgTree" 
                        :data="orgTreeData" 
                        node-key="organizationcode" 
                        :expand-on-click-node="false" 
                        :default-expanded-keys="['1']"
                        :props="defaultProps" 
                        @node-click="orgSelect"></el-tree>
                </div>
            </div>
        </div>
        <div class="tools">
            <el-button @click="handleRelate">关联人员</el-button>
        </div>
        <div class="list">
            <el-table :data="list" @selection-change="listSelect" border>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="所属部门" prop="orgname"></el-table-column>
                <el-table-column label="姓名" prop="contact"></el-table-column>
                <el-table-column label="账号" prop="username1"></el-table-column>
            </el-table>
            <div class="paging">
                <el-pagination @current-change="handleCurrentPage" :current-page.sync="paging.currentPage" :page-size="paging.pageSize" layout="total, prev, pager, next" :total="paging.totalSize"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import Bus from '../../bus/bus'
    import {API_ROOT} from '../../config/index'
    export default {
        props: ['keyCode'],
        data: function(){
            return {
                orgTreeData: [],
                filter: {
                    contact: '',
                    orgcode: '',
                    username: '',
                    curOrgNode: {
                        organizationcode: '',
                        organizationname: ''
                    },
                    orgTree: false
                },
                list: [],
                selection: [],
                paging: {
                    currentPage: 1,
                    pageSize: 15,
                    totalSize: 30
                },
                defaultProps: {
                    label: 'organizationname',
                    children: 'children',
                }
            }
        },
        created: function(){
             this.init()
        },
        watch: {
            keyCode(){
                // 加载列表数据
                this.loadListData()
            }
        },
        methods: {
            init(){
                // 加载列表数据
                if(this.keyCode) {
                    this.loadListData()
                }
                // 注册列表更新事件
                Bus.$off('updateUndistributedList').$on('updateUndistributedList',() => {
                    this.loadListData()
                })
                // 初始化组织数据
                this.loadOrgData()
            },
            // 加载列表数据
            loadListData() {
                this.$http.post(`/platserv/role/accountList`,{
                    page: this.paging.currentPage,
                    rows: this.paging.pageSize,
                    platrolecode: this.keyCode,
                    contact: this.filter.contact,
                    orgcode: this.filter.curOrgNode.organizationcode,
                    username: this.filter.username,
                    bindstatus: '2'
                }).then(function(res){
                    this.list = res.data.resp_data.data
                    this.paging.totalSize = res.data.resp_data.resultCount
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 加载组织结构数据
            loadOrgData() {
                this.$http.post(`/platserv/organiztion/tree`,{
                    af_dimensionid: '1'
                }).then(function(res){
                    this.orgTreeData = res.data.resp_data
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            showOrgTree() {
                this.filter.orgTree = true
            },
            // 组织选择
            orgSelect(data) {
                this.filter.curOrgNode.organizationcode = data.organizationcode
                this.filter.curOrgNode.organizationname = data.organizationname
                this.filter.orgTree = false
                this.loadListData()
            },
            handleFilterOrg() {
                if(!this.filter.curOrgNode.organizationname) {
                    this.filter.curOrgNode.organizationcode = ''
                    this.loadListData()
                }
            },
            // 关联人员
            handleRelate() {
                if(this.selection.length === 0){
                    this.$message.warning('请选择人员！')
                    return
                }
                this.$confirm('确定关联人员？').then(() => {
                    let codeArr = []
                    this.selection.forEach(item => {
                        codeArr.push(item.plataccountcode)
                    })
                    this.postGrantUser(codeArr).then(() => {
                        this.loadListData()
                        Bus.$emit('updateDistributedList')
                    })
                }).catch(() => {})
            },
            // 人员选择
            listSelect(data) {
                this.selection = data
            },
            // 页码切换
            handleCurrentPage(val) {
                this.paging.currentPage = val
                this.loadListData()
            },
            // 关联人员接口
            postGrantUser(codeArr) {
                return new Promise((resolve,reject) => {
                    this.$http.post('/platserv/role/grantUser',{
                        platrolecode: this.keyCode,
                        plataccountcodes: codeArr
                    }).then(res => {
                        this.$message.success('人员关联成功')
                        resolve()
                    }).catch(error => {
                        this.errorMessage(error)
                        reject()
                    })
                })
            },
            // 显示错误消息
            errorMessage(error) {
                let msg = (error.body && error.body.error_code) || error.statusText || error
                this.$message.error(msg)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Undistributed.vue?87156562